import React from "react";
import "../Layout.css";
import "../Article.css";
import PostDate from "../Article/Posts/Posts.json";
import { NavLink } from "react-router-dom";

export default function Nav() {
    return (
        <nav className="menu">
            <ul>
                <li>
                    <NavLink activeClassName="active" exact to="/">
                        Top
                    </NavLink>
                </li>
                {Object.keys(PostDate).map((posts) => {
                    return (
                        <li>
                            {console.log(PostDate[posts].URL)}
                            <NavLink
                                activeClassName="active"
                                exact
                                to={`${PostDate[posts].URL}`}
                            >
                                {PostDate[posts].Title}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
